import React, { FunctionComponent } from 'react';

import { PublishStatusMessage as PublishStatus } from 'inbox/status-message/StatusMessage';
import { UserType } from 'reviews2/feed/review-yeti/reply/ReviewReply.types';
import { ReplyProps } from 'reviews2/feed/review-yeti/reply/ReviewReply.types';
import { isPending } from 'reviews2/feed/review-yeti/reply/ReviewReply.util';

import 'reviews2/feed/review-yeti/reply/status/ReplyStatus.scss';

export const ReplyStatus: FunctionComponent<ReplyProps> = ({ context, reply }) => {
    const { review } = context;

    if (![UserType.Business, UserType.User].includes(reply.poster?.userType!) || isPending(reply)) {
        return null;
    }

    return <PublishStatus currentConversation={review} message={reply} />;
};
